import React from 'react';

// Saldo a favor (abono adelantado) del cliente seleccionado; null si no hay cliente
export const saldoDelCliente = (customer) => (customer ? parseFloat(customer.balance) || 0 : null);

// ¿Se puede cobrar este total completo con el saldo a favor del cliente?
export const saldoAlcanza = (customer, total) => {
    const saldo = saldoDelCliente(customer);
    return saldo !== null && saldo >= total - 0.009;
};

// Etiqueta compacta con el saldo a favor; no muestra nada si el cliente no tiene saldo
export const EtiquetaSaldo = ({ customer, style }) => {
    const saldo = saldoDelCliente(customer);
    if (!saldo || saldo <= 0) return null;
    return (
        <span style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '4px',
            backgroundColor: '#ede9fe',
            color: '#6d28d9',
            border: '1px solid #ddd6fe',
            padding: '2px 8px',
            borderRadius: '20px',
            fontSize: '11px',
            fontWeight: '700',
            whiteSpace: 'nowrap',
            ...style
        }}>
            <i className="bi bi-wallet2"></i> Saldo a favor: ${saldo.toFixed(2)}
        </span>
    );
};

/**
 * Aviso que se muestra al elegir "Saldo a favor" como forma de pago:
 * indica de quién se descuenta, cuánto tiene y cuánto le queda (o cuánto falta).
 */
const AvisoSaldoFavor = ({ customer, total }) => {
    const saldo = saldoDelCliente(customer);
    const ok = saldoAlcanza(customer, total);

    let contenido;
    if (saldo === null) {
        contenido = <>Selecciona el <strong>cliente</strong> para descontar de su saldo a favor.</>;
    } else if (ok) {
        contenido = (
            <>
                Se descuenta del saldo de <strong>{customer.first_name} {customer.last_name}</strong>:
                tiene <strong>${saldo.toFixed(2)}</strong>, le quedará <strong>${(saldo - total).toFixed(2)}</strong>.
            </>
        );
    } else {
        contenido = (
            <>
                <strong>{customer.first_name} {customer.last_name}</strong> solo tiene <strong>${saldo.toFixed(2)}</strong> de saldo a favor
                (faltan ${(total - saldo).toFixed(2)}). Usa <strong>Mixto</strong> para pagar el resto con otra forma de pago.
            </>
        );
    }

    return (
        <div style={{
            padding: '0.85rem 1rem',
            backgroundColor: ok ? '#f5f3ff' : '#fef2f2',
            borderRadius: '8px',
            border: `1px solid ${ok ? '#ddd6fe' : '#fecaca'}`,
            color: ok ? '#5b21b6' : '#991b1b',
            fontSize: '0.875rem',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
        }}>
            <i className={`bi ${ok ? 'bi-wallet2' : 'bi-exclamation-triangle-fill'}`} style={{ fontSize: '18px' }}></i>
            <span>{contenido}</span>
        </div>
    );
};

export default AvisoSaldoFavor;
